import { gql } from '@apollo/client';

export const ListingStatusesSubscriptionGQL = gql`
  subscription ListingStatusSubscription($listingId: ID!) {
    listingCurrentStatus(listingId: $listingId) {
      name
      createdAt
    }
  }
`;

export const ListingNotesSubscriptionGQL = gql`
  subscription ListingNoteSubscription($listingId: ID!) {
    listingNote(listingId: $listingId) {
      userOnly
      updatedAt
      note
      tag
      listingId
      id
      createdAt
      submitter {
        id
        firstName
        lastName
        imageUrl
      }
      previousValue
    }
  }
`;

export const ListingInternalValuationAppraisalGQL = gql`
  subscription ListingAppraisalSubscription($listingId: ID!) {
    listingAppraisal(listingId: $listingId) {
      amount
      crGrade
      createdAt
      createdByUser {
        id
        firstName
        lastName
        imageUrl
      }
      id
      listingId
      notes
      previousValue
      updatedAt
    }
  }
`;

export const ListingInternalValuationValuationSubscriptionGQL = gql`
  subscription ListingValuationSubscription($listingId: ID!) {
    listingInternalValuation(listingId: $listingId) {
      id
      amount
      crGrade
      createdByUser {
        id
        imageUrl
        firstName
        lastName
      }
      createdByUserId
      listingId
      notes
      createdAt
      updatedAt
    }
  }
`;

export const ListingInternalValuationOfferSubscriptionGQL = gql`
  subscription ListingOfferSubscription($listingId: ID!) {
    listingOffer(listingId: $listingId) {
      amount
      createdAt
      id
      notes
      updatedAt
      createdByUserId
      listingId
    }
  }
`;

const activityUserFields = `
  userId
  user {
    id
    firstName
    lastName
    imageUrl
  }
  isConnected
  lastActiveAt
`;

export const ListingLiveActivitySubscriptionGQL = gql`
  subscription ListingLiveActivitySubscription($listingId: ID!, $isObserver: Boolean) {
    liveActivity(activityChannel: Listing, entityId: $listingId, isObserver: $isObserver) {
      users {
        ${activityUserFields}
      }
      userBecameActive {
        ${activityUserFields}
      }
      userBecameInactive {
        ${activityUserFields}
      }
    }
  }
`;

export const ListingTagsSubscriptionGQL = gql`
  subscription ListingTagsSubscription($listingId: ID!) {
    listingTags(listingId: $listingId) {
      id
      name
    }
  }
`;

export const ValuationsSubscriptionGQL = gql`
  subscription ListingValuationsSubscription($listingId: ID!) {
    listingValuation(listingId: $listingId) {
      amount
      createdAt
      createdByUser {
        firstName
        lastName
        id
      }
      extra
      id
      listingId
      type
      updatedAt
    }
  }
`;

export const ListingActivitySubscriptionGQL = gql`
  subscription ListingActivitySubscription($listingId: ID!) {
    listingSharedActivity(listingId: $listingId) {
      internal {
        organization {
          id
          name
          imageUrl
          userRoles {
            id
            owner
            user {
              id
              firstName
              lastName
            }
          }
        }
        room {
          id
          name
          type
          unreadMessagesCount
          updatedAt
          listingId
          lastMessageText
          lastMessageAt
          createdAt
        }
        user {
          id
          lastName
          firstName
          imageUrl
          email
        }
      }
      sharedBy {
        organization {
          id
          name
          imageUrl
          userRoles {
            id
            owner
            user {
              id
              firstName
              lastName
            }
          }
        }
        room {
          id
          name
          type
          unreadMessagesCount
          updatedAt
          listingId
          lastMessageText
          lastMessageAt
          createdAt
        }
        user {
          id
          lastName
          firstName
          imageUrl
          email
        }
      }
      sharedWith {
        organization {
          id
          name
          imageUrl
          userRoles {
            id
            owner
            user {
              id
              firstName
              lastName
            }
          }
        }
        room {
          id
          name
          type
          unreadMessagesCount
          updatedAt
          listingId
          lastMessageText
          lastMessageAt
          createdAt
        }
        user {
          id
          lastName
          firstName
          imageUrl
          email
        }
      }
    }
  }
`;

export const ListingHistoryCreatedSubscriptionGQL = gql`
  subscription ListingHistoryCreatedSubscription($listingId: ID!) {
    listingHistoryCreated(listingId: $listingId) {
      createdByUser {
        firstName
        lastName
        imageUrl
      }
      createdAt
      messageHtml
    }
  }
`;
